<div class="filter-container">
  <div class="row">
    <div class="filter-window col-12">
      <div class="row">
        <div class="title-header col-12">
          <i class="fa fa-filter" aria-hidden="true"></i>
          <span class="title">{{ 'ADMIN.FILTER.TITLE' | translate }}</span>
          <span class="subtitle">{{ 'ADMIN.GENERAL.CLIENT_USERS' | translate }}</span>
        </div>
      </div>

      <div class="row">
        <div class="form-container col-12">
          <form [formGroup]="userFilterForm">
            <div class="row">
              <div class="col-12 col-lg-6">

                <div class="form-group row cell">
                  <eps-text-input
                    label="ADMIN.FILTER.LABELS.FIRST_NAME"
                    formControlName="firstName"
                    [showErrors]="false"
                    hideOptionalMarker
                  ></eps-text-input>
                </div>
                <div class="form-group row cell">
                  <eps-text-input
                    label="ADMIN.FILTER.LABELS.LAST_NAME"
                    formControlName="lastName"
                    [showErrors]="false"
                    hideOptionalMarker
                  ></eps-text-input>
                </div>
                <div class="form-group row cell">
                  <eps-text-input
                    label="ADMIN.FILTER.LABELS.EMAIL"
                    formControlName="email"
                    [showErrors]="false"
                    hideOptionalMarker
                  ></eps-text-input>
                </div>
                <div class="form-group row cell">
                  <eps-select
                    label="ADMIN.FILTER.LABELS.SALES_ORGANISATION"
                    formControlName="salesOrganisationIds"
                    [options]="salesOrganisations"
                    [showErrors]="false"
                    hideOptionalMarker
                  ></eps-select>
                </div>
                <div class="form-group row cell">
                  <eps-select
                    label="ADMIN.FILTER.LABELS.CUSTOMERS"
                    formControlName="soldToIds"
                    [disabled]="!soldTos || soldTos.length === 0"
                    [options]="soldTos"
                    [showErrors]="false"
                    multiple
                    hideOptionalMarker
                  ></eps-select>
                  <div *ngIf="soldToFieldIsInvalid" class="error-message">
                    {{ 'ADMIN.FILTER.MESSAGES.EMPTY_SOLDTOS' | translate}}
                  </div>
                </div>
              </div>
              <div class="col-12 col-lg-6">
                <div class="form-group row">
                  <eps-label-body label="ADMIN.CLIENT_USERS.ACTIVE" labelWidth="220px">
                    <div class="checkboxes">
                      <eps-checkbox labelPosition="none" checkboxLabel="SHARED.BUTTONS.YES" formControlName="isActive"></eps-checkbox>&nbsp;&nbsp;&nbsp;
                      <eps-checkbox labelPosition="none" checkboxLabel="SHARED.BUTTONS.NO" formControlName="isNotActive"></eps-checkbox>
                    </div>
                  </eps-label-body>
                </div>
                <div class="form-group row">
                  <eps-label-body label="ADMIN.FILTER.LABELS.ASSIGNED" labelWidth="220px">
                    <div class="checkboxes">
                      <eps-checkbox labelPosition="none" checkboxLabel="SHARED.BUTTONS.YES" formControlName="isAssigned"></eps-checkbox>&nbsp;&nbsp;&nbsp;
                      <eps-checkbox labelPosition="none" checkboxLabel="SHARED.BUTTONS.NO" formControlName="isNotAssigned"></eps-checkbox>
                    </div>
                  </eps-label-body>
                </div>
                <div class="form-group row">
                  <eps-label-body label="ADMIN.CLIENT_USERS.CAN_USE_EMAIL_ACTORS" labelWidth="220px">
                    <div class="checkboxes">
                      <eps-checkbox labelPosition="none" checkboxLabel="SHARED.BUTTONS.YES" formControlName="usesEmailActors"></eps-checkbox>&nbsp;&nbsp;&nbsp;
                      <eps-checkbox labelPosition="none" checkboxLabel="SHARED.BUTTONS.NO" formControlName="cannotUseEmailActors"></eps-checkbox>
                    </div>
                  </eps-label-body>
                </div>
                <div class="form-group row">
                  <eps-label-body label="ADMIN.CLIENT_USERS.IS_SUPER_USER" labelWidth="220px">
                    <div class="checkboxes">
                      <eps-checkbox labelPosition="none" checkboxLabel="SHARED.BUTTONS.YES" formControlName="isTransporter"></eps-checkbox>&nbsp;&nbsp;&nbsp;
                      <eps-checkbox labelPosition="none" checkboxLabel="SHARED.BUTTONS.NO" formControlName="isNotTransporter"></eps-checkbox>
                    </div>
                  </eps-label-body>
                </div>
                <div class="form-group row">
                  <eps-label-body label="ADMIN.CLIENT_USERS.CAN_ACCESS_HOME_MARKET_BONUS" labelWidth="220px">
                    <div class="checkboxes">
                      <eps-checkbox labelPosition="none" checkboxLabel="SHARED.BUTTONS.YES" formControlName="canAccessHomeMarketBonus"></eps-checkbox>&nbsp;&nbsp;&nbsp;
                      <eps-checkbox labelPosition="none" checkboxLabel="SHARED.BUTTONS.NO" formControlName="cannotAccessHomeMarketBonus"></eps-checkbox>
                    </div>
                  </eps-label-body>
                </div>
              </div>
            </div>
            <div class="row center-xs end-sm end-lg filter-buttons">
              <eps-button
                label="SHARED.BUTTONS.CLEAR_FILTERS"
                buttonIcon="eraser"
                (buttonClick)="resetFilter()"
                [disabled]="isLoading"
                ></eps-button>
              <eps-button
                label="{{ 'ADMIN.FILTER.TITLE' | translate }} {{ 'ADMIN.GENERAL.CLIENT_USERS' | translate }}"
                buttonIcon="filter"
                (buttonClick)="filterClicked()"
                [disabled]="userFilterForm.invalid || isLoading || soldToFieldIsInvalid"
                [busy]="isLoading"
                submit
                ></eps-button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
